const CURRENCY_FMT = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const CURRENCY_PRECISE_FMT = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const NUMBER_FMT = new Intl.NumberFormat('en-US')

export const formatCurrency = (value) => CURRENCY_FMT.format(value ?? 0)

export const formatPrice = (value) => CURRENCY_PRECISE_FMT.format(value ?? 0)

export const formatSignedCurrency = (value) => {
  const sign = value > 0 ? '+' : ''
  return `${sign}${CURRENCY_FMT.format(value ?? 0)}`
}

export const formatNumber = (value) => NUMBER_FMT.format(value ?? 0)

export const formatPercent = (ratio, digits = 1) =>
  `${((ratio ?? 0) * 100).toFixed(digits)}%`

export const formatSignedPercent = (ratio, digits = 1) => {
  const sign = ratio > 0 ? '+' : ''
  return `${sign}${((ratio ?? 0) * 100).toFixed(digits)}%`
}

export const formatCompact = (value) =>
  new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(value ?? 0)

export const formatTime = (isoString) => {
  if (!isoString) return ''
  return new Date(isoString).toLocaleString('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
}

export const relativeTime = (isoString) => {
  if (!isoString) return ''
  const diffMs = Date.now() - new Date(isoString).getTime()
  const mins = Math.round(diffMs / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.round(mins / 60)
  if (hours < 24) return `${hours}h ago`
  return `${Math.round(hours / 24)}d ago`
}
